import { useTranslation } from 'react-i18next';

/**
 * Custom hook that returns an array of appointment place options.
 * Each option has a label and value property.
 *
 * @returns An array of appointment place options with translated labels.
 */
export const useAppointmentPlacesOptions = () => {
  const { t } = useTranslation();

  return [
    { label: t('appointment_types.at_the_clinic'), value: 'Clinic' },
    {
      label: t('appointment_types.teleconsultation'),
      value: 'Teleconsultation',
    },
  ];
};
